import { useIncident } from '../hooks/incidentHooks';
import { useState, useRef } from 'react';
import InitialResponseStepper from './InitialResponseStepper';
import InitialResponseOverview from './InitialResponseOverview';
import InitialResponseObjectivesActions from './InitialResponseObjectivesActions';
import { InitialResponseTabsType } from './InitialResponseTabs';
import { InitialResponseResources } from './InitialResponseResources';
import InitialResponseBriefing from './InitialResponseBriefing';
import SafetyAnalysis from './SafetyAnalysis/SafetyAnalysis';
import classNames from 'classnames';
import ReportsView from 'components/Reports/ReportsView';
import { useICSContext } from '../planningView/ICSContext';
import IAPRoster from '../IAPRoster';
import { UscgMapLayout } from 'components/MapPage/UscgMapLayout';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';
import { CorporateViewTabGroup } from 'components/MapPage/CorporateViewTabGroup';

// Maps context tab values to InitialResponseTabsType
const TAB_CONTEXT_MAP: Record<string, InitialResponseTabsType> = {
  'objectives-actions': 'Objectives & Actions',
  overview: 'Overview',
  'incident-roster': 'Incident Roster',
  resources: 'Resources',
  'safety-analysis': 'Safety Analysis',
  'incident-briefing': 'Incident Briefing',
  reports: 'Reports',
};

const InitialResponseReports = () => {
  return <ReportsView />;
};

const PhaseMap: Record<InitialResponseTabsType, React.ReactNode> = {
  Overview: <InitialResponseOverview />,
  'Objectives & Actions': <InitialResponseObjectivesActions />,
  'Incident Roster': <IAPRoster />,
  Resources: <InitialResponseResources />,
  'Safety Analysis': <SafetyAnalysis />,
  'Incident Briefing': <InitialResponseBriefing />,
  Reports: <InitialResponseReports />,
};

const InitialResponsePage = () => {
  const mainContentRef = useRef<HTMLDivElement>(null);
  const { isMapVisible } = useUscgMapContext();

  const incident = useIncident();

  // Read initial tab from ICSContext (set by AI citation navigation)
  const { initialResponseTab, setInitialResponseTab } = useICSContext();
  const getInitialTab = (): InitialResponseTabsType => {
    if (initialResponseTab && TAB_CONTEXT_MAP[initialResponseTab]) {
      // Clear context after reading to prevent stale navigation
      setInitialResponseTab('');
      return TAB_CONTEXT_MAP[initialResponseTab];
    }
    return 'Overview';
  };
  const [currentTab, setCurrentTab] =
    useState<InitialResponseTabsType>(getInitialTab);

  const mainContentClasses = classNames('maincontent iap-response__main', {
    'maincontent-no-padding': isMapVisible,
  });

  if (incident.data === undefined) {
    return null;
  }

  return (
    <div className="iap-response">
      {isMapVisible ? (
        <div className={mainContentClasses} ref={mainContentRef}>
          <UscgMapLayout>
            <CorporateViewTabGroup
              ics={true}
              currentMode={''}
              updateMode={() => {}}
              currentPhase={0}
            />
          </UscgMapLayout>
        </div>
      ) : (
        <div className={mainContentClasses} ref={mainContentRef}>
          <InitialResponseStepper
            currentPhase={currentTab}
            updatePhase={(e) => {
              setCurrentTab(e);
            }}
          />

          <div className="planning-container no-header">
            <div>{PhaseMap[currentTab]}</div>
          </div>
        </div>
      )}
    </div>
  );
};
export default InitialResponsePage;
